// Thu Mar 27 06:04:37 GMT 2025

import * as models from "../crm-web-api-models"

export enum TradingAccountProp {
	BrokerCode = 'brokerCode',
	BrokerGroup = 'brokerGroup',
	BusinessGroup$list = 'businessGroup$list',
	CreatedBy = 'createdBy',
	CreationTime = 'creationTime',
	Currency = 'currency',
	Customer$name = 'customer$name',
	CustomerBrandCompanyId = 'customer.brand.company.id',
	CustomerId = 'customer.id',
	CustomerOneClickClosingAccountStatus = 'customer.oneClickClosingAccountStatus',
	CustomerPersonFirstName = 'customer.person.firstName',
	CustomerPersonLastName = 'customer.person.lastName',
	DeactivationSource = 'deactivationSource',
	DemoExpirationDate = 'demoExpirationDate',
	Description = 'description',
	ExistsAtPlatform = 'existsAtPlatform',
	ForbidPasswordSync = 'forbidPasswordSync',
	Id = 'id',
	Islamic = 'islamic',
	LastSynchErrorMsg = 'lastSynchErrorMsg',
	Leverage = 'leverage',
	Leverage$list = 'leverage$list',
	ModificationTime = 'modificationTime',
	ModifiedBy = 'modifiedBy',
	MoneyManager = 'moneyManager',
	Name = 'name',
	NumberOfDeposits = 'numberOfDeposits',
	NumberOfDoneDeposits = 'numberOfDoneDeposits',
	NumberOfWithdrawals = 'numberOfWithdrawals',
	Omnibus = 'omnibus',
	PaymentReference = 'paymentReference',
	PlatformAccountId = 'platformAccountId',
	ReportUrl = 'reportUrl',
	ReportingType = 'reportingType',
	TaxReportUrl = 'taxReportUrl',
	Test = 'test',
	TitleTransfer = 'titleTransfer',
	TotalDeposits = 'totalDeposits',
	TotalDoneDeposits = 'totalDoneDeposits',
	TotalWithdrawals = 'totalWithdrawals',
	TradePlatformDepartment = 'tradePlatformDepartment',
	TradePlatformProfiles = 'tradePlatformProfiles',
	TradePlatformServer = 'tradePlatformServer',
	TradePlatformType = 'tradePlatformType',
	TradingAccountInstrumentType = 'tradingAccountInstrumentType',
	TradingAccountMode = 'tradingAccountMode',
	TradingAccountStatus = 'tradingAccountStatus',
	TradingAccountType = 'tradingAccountType',
	TradingTotalsEquity = 'tradingTotals.equity',
	TradingTotalsEquityTACcy = 'tradingTotals.equityTACcy',
	TradingTotalsMarginFree = 'tradingTotals.marginFree',
	TradingTotalsMarginFreeTACcy = 'tradingTotals.marginFreeTACcy',
	TradingTotalsMarginLevel = 'tradingTotals.marginLevel',
	TradingTotalsModificationTime = 'tradingTotals.modificationTime',
	TtaClearingCode = 'ttaClearingCode',
	TtaClientDomain = 'ttaClientDomain',
	UserName = 'userName'
}

export type TradingAccountPropBrokerCode = {
	[TradingAccountProp.BrokerCode] : string | null
}
export type TradingAccountPropBrokerGroup = {
	[TradingAccountProp.BrokerGroup] : string | null
}
export type TradingAccountPropBusinessGroup$list = {
	[TradingAccountProp.BusinessGroup$list] : models.CollectionValueDto<number, boolean>[]
}
export type TradingAccountPropCreatedBy = {
	[TradingAccountProp.CreatedBy] : models.UserDto
}
export type TradingAccountPropCreationTime = {
	[TradingAccountProp.CreationTime] : number | null
}
export type TradingAccountPropCurrency = {
	[TradingAccountProp.Currency] : 'USD' | 'EUR' | 'GBP' | 'CAD' | 'JPY' | 'PLN' | 'AUD' | 'NOK' | 'SEK' | 'CZK' | 'DKK' | 'RUB' | 'RON' | 'BGN' | 'HRK' | 'HUF' | 'ZAR' | 'NZD' | 'LKR' | 'CHF' | 'INR' | 'MXN' | 'AED' | 'BRL' | 'COP' | null
}
export type TradingAccountPropCustomer$name = {
	[TradingAccountProp.Customer$name] : string
}
export type TradingAccountPropCustomerBrandCompanyId = {
	[TradingAccountProp.CustomerBrandCompanyId] : number | null
}
export type TradingAccountPropCustomerId = {
	[TradingAccountProp.CustomerId] : number | null
}
export type TradingAccountPropCustomerOneClickClosingAccountStatus = {
	[TradingAccountProp.CustomerOneClickClosingAccountStatus] : 'OPEN' | 'DECLINED' | 'TERMINATED' | null
}
export type TradingAccountPropCustomerPersonFirstName = {
	[TradingAccountProp.CustomerPersonFirstName] : string | null
}
export type TradingAccountPropCustomerPersonLastName = {
	[TradingAccountProp.CustomerPersonLastName] : string | null
}
export type TradingAccountPropDeactivationSource = {
	[TradingAccountProp.DeactivationSource] : 'UNDEFINED' | 'AES' | 'WEBSITE' | null
}
export type TradingAccountPropDemoExpirationDate = {
	[TradingAccountProp.DemoExpirationDate] : number | null
}
export type TradingAccountPropDescription = {
	[TradingAccountProp.Description] : string | null
}
export type TradingAccountPropExistsAtPlatform = {
	[TradingAccountProp.ExistsAtPlatform] : boolean | null
}
export type TradingAccountPropForbidPasswordSync = {
	[TradingAccountProp.ForbidPasswordSync] : boolean | null
}
export type TradingAccountPropId = {
	[TradingAccountProp.Id] : number
}
export type TradingAccountPropIslamic = {
	[TradingAccountProp.Islamic] : boolean | null
}
export type TradingAccountPropLastSynchErrorMsg = {
	[TradingAccountProp.LastSynchErrorMsg] : string | null
}
export type TradingAccountPropLeverage = {
	[TradingAccountProp.Leverage] : any /* Entity */
}
export type TradingAccountPropLeverage$list = {
	[TradingAccountProp.Leverage$list] : models.CollectionValueDto<number, never>[]
}
export type TradingAccountPropModificationTime = {
	[TradingAccountProp.ModificationTime] : number | null
}
export type TradingAccountPropModifiedBy = {
	[TradingAccountProp.ModifiedBy] : models.UserDto
}
export type TradingAccountPropMoneyManager = {
	[TradingAccountProp.MoneyManager] : models.CustomerDto
}
export type TradingAccountPropName = {
	[TradingAccountProp.Name] : string | null
}
export type TradingAccountPropNumberOfDeposits = {
	[TradingAccountProp.NumberOfDeposits] : number | null
}
export type TradingAccountPropNumberOfDoneDeposits = {
	[TradingAccountProp.NumberOfDoneDeposits] : number | null
}
export type TradingAccountPropNumberOfWithdrawals = {
	[TradingAccountProp.NumberOfWithdrawals] : number | null
}
export type TradingAccountPropOmnibus = {
	[TradingAccountProp.Omnibus] : boolean | null
}
export type TradingAccountPropPaymentReference = {
	[TradingAccountProp.PaymentReference] : string | null
}
export type TradingAccountPropPlatformAccountId = {
	[TradingAccountProp.PlatformAccountId] : string | null
}
export type TradingAccountPropReportUrl = {
	[TradingAccountProp.ReportUrl] : string | null
}
export type TradingAccountPropReportingType = {
	[TradingAccountProp.ReportingType] : 'Single' | 'Delegated' | 'DoubleDelegated' | null
}
export type TradingAccountPropTaxReportUrl = {
	[TradingAccountProp.TaxReportUrl] : string | null
}
export type TradingAccountPropTest = {
	[TradingAccountProp.Test] : boolean | null
}
export type TradingAccountPropTitleTransfer = {
	[TradingAccountProp.TitleTransfer] : 'Undefined' | 'None' | 'FullEquity' | 'MarginOnly' | null
}
export type TradingAccountPropTotalDeposits = {
	[TradingAccountProp.TotalDeposits] : number | null
}
export type TradingAccountPropTotalDoneDeposits = {
	[TradingAccountProp.TotalDoneDeposits] : number | null
}
export type TradingAccountPropTotalWithdrawals = {
	[TradingAccountProp.TotalWithdrawals] : number | null
}
export type TradingAccountPropTradePlatformDepartment = {
	[TradingAccountProp.TradePlatformDepartment] : string
}
export type TradingAccountPropTradePlatformProfiles = {
	[TradingAccountProp.TradePlatformProfiles] : string | null
}
export type TradingAccountPropTradePlatformServer = {
	[TradingAccountProp.TradePlatformServer] : string
}
export type TradingAccountPropTradePlatformType = {
	[TradingAccountProp.TradePlatformType] : 'ACT' | 'MT4' | 'FOREX_TRADER' | 'IFP_GAMING' | 'MULTI_TRADER' | 'WEB_FX' | 'SPOT_OPTION' | 'COSMOS' | 'BINARYOPTIONS' | 'PLUS500' | 'MT5' | 'TTA' | 'DMA' | null
}
export type TradingAccountPropTradingAccountInstrumentType = {
	[TradingAccountProp.TradingAccountInstrumentType] : 'CFD' | 'SPREAD_BETTING' | 'QUANT_RANKS' | 'SHARE_DEALING' | 'ASSET_MANAGEMENT' | 'CRYPTO' | null
}
export type TradingAccountPropTradingAccountMode = {
	[TradingAccountProp.TradingAccountMode] : 'FULL' | 'READ_ONLY' | 'LONG_ONLY' | 'SHORT_ONLY' | 'NO' | null
}
export type TradingAccountPropTradingAccountStatus = {
	[TradingAccountProp.TradingAccountStatus] : 'INACTIVE' | 'ACTIVE' | 'CLOSED' | 'PENDING' | 'ARCHIVED' | null
}
export type TradingAccountPropTradingAccountType = {
	[TradingAccountProp.TradingAccountType] : 'REAL' | 'DEMO' | null
}
export type TradingAccountPropTradingTotalsEquity = {
	[TradingAccountProp.TradingTotalsEquity] : number | null
}
export type TradingAccountPropTradingTotalsEquityTACcy = {
	[TradingAccountProp.TradingTotalsEquityTACcy] : number | null
}
export type TradingAccountPropTradingTotalsMarginFree = {
	[TradingAccountProp.TradingTotalsMarginFree] : number | null
}
export type TradingAccountPropTradingTotalsMarginFreeTACcy = {
	[TradingAccountProp.TradingTotalsMarginFreeTACcy] : number | null
}
export type TradingAccountPropTradingTotalsMarginLevel = {
	[TradingAccountProp.TradingTotalsMarginLevel] : number | null
}
export type TradingAccountPropTradingTotalsModificationTime = {
	[TradingAccountProp.TradingTotalsModificationTime] : number | null
}
export type TradingAccountPropTtaClearingCode = {
	[TradingAccountProp.TtaClearingCode] : 'Default' | 'Retail' | 'LAPI' | null
}
export type TradingAccountPropTtaClientDomain = {
	[TradingAccountProp.TtaClientDomain] : string | null
}
export type TradingAccountPropUserName = {
	[TradingAccountProp.UserName] : string | null
}


export type TradingAccount = 
	TradingAccountPropBrokerCode & 
	TradingAccountPropBrokerGroup & 
	TradingAccountPropBusinessGroup$list & 
	TradingAccountPropCreatedBy & 
	TradingAccountPropCreationTime & 
	TradingAccountPropCurrency & 
	TradingAccountPropCustomer$name & 
	TradingAccountPropCustomerBrandCompanyId & 
	TradingAccountPropCustomerId & 
	TradingAccountPropCustomerOneClickClosingAccountStatus & 
	TradingAccountPropCustomerPersonFirstName & 
	TradingAccountPropCustomerPersonLastName & 
	TradingAccountPropDeactivationSource & 
	TradingAccountPropDemoExpirationDate & 
	TradingAccountPropDescription & 
	TradingAccountPropExistsAtPlatform & 
	TradingAccountPropForbidPasswordSync & 
	TradingAccountPropId & 
	TradingAccountPropIslamic & 
	TradingAccountPropLastSynchErrorMsg & 
	TradingAccountPropLeverage & 
	TradingAccountPropLeverage$list & 
	TradingAccountPropModificationTime & 
	TradingAccountPropModifiedBy & 
	TradingAccountPropMoneyManager & 
	TradingAccountPropName & 
	TradingAccountPropNumberOfDeposits & 
	TradingAccountPropNumberOfDoneDeposits & 
	TradingAccountPropNumberOfWithdrawals & 
	TradingAccountPropOmnibus & 
	TradingAccountPropPaymentReference & 
	TradingAccountPropPlatformAccountId & 
	TradingAccountPropReportUrl & 
	TradingAccountPropReportingType & 
	TradingAccountPropTaxReportUrl & 
	TradingAccountPropTest & 
	TradingAccountPropTitleTransfer & 
	TradingAccountPropTotalDeposits & 
	TradingAccountPropTotalDoneDeposits & 
	TradingAccountPropTotalWithdrawals & 
	TradingAccountPropTradePlatformDepartment & 
	TradingAccountPropTradePlatformProfiles & 
	TradingAccountPropTradePlatformServer & 
	TradingAccountPropTradePlatformType & 
	TradingAccountPropTradingAccountInstrumentType & 
	TradingAccountPropTradingAccountMode & 
	TradingAccountPropTradingAccountStatus & 
	TradingAccountPropTradingAccountType & 
	TradingAccountPropTradingTotalsEquity & 
	TradingAccountPropTradingTotalsEquityTACcy & 
	TradingAccountPropTradingTotalsMarginFree & 
	TradingAccountPropTradingTotalsMarginFreeTACcy & 
	TradingAccountPropTradingTotalsMarginLevel & 
	TradingAccountPropTradingTotalsModificationTime & 
	TradingAccountPropTtaClearingCode & 
	TradingAccountPropTtaClientDomain & 
	TradingAccountPropUserName

export const TRADING_ACCOUNT_PROPERTY_NAMES = Object.freeze([TradingAccountProp.BrokerCode, TradingAccountProp.BrokerGroup, TradingAccountProp.BusinessGroup$list, TradingAccountProp.CreatedBy, TradingAccountProp.CreationTime, TradingAccountProp.Currency, TradingAccountProp.Customer$name, TradingAccountProp.CustomerBrandCompanyId, TradingAccountProp.CustomerId, TradingAccountProp.CustomerOneClickClosingAccountStatus, TradingAccountProp.CustomerPersonFirstName, TradingAccountProp.CustomerPersonLastName, TradingAccountProp.DeactivationSource, TradingAccountProp.DemoExpirationDate, TradingAccountProp.Description, TradingAccountProp.ExistsAtPlatform, TradingAccountProp.ForbidPasswordSync, TradingAccountProp.Id, TradingAccountProp.Islamic, TradingAccountProp.LastSynchErrorMsg, TradingAccountProp.Leverage, TradingAccountProp.Leverage$list, TradingAccountProp.ModificationTime, TradingAccountProp.ModifiedBy, TradingAccountProp.MoneyManager, TradingAccountProp.Name, TradingAccountProp.NumberOfDeposits, TradingAccountProp.NumberOfDoneDeposits, TradingAccountProp.NumberOfWithdrawals, TradingAccountProp.Omnibus, TradingAccountProp.PaymentReference, TradingAccountProp.PlatformAccountId, TradingAccountProp.ReportUrl, TradingAccountProp.ReportingType, TradingAccountProp.TaxReportUrl, TradingAccountProp.Test, TradingAccountProp.TitleTransfer, TradingAccountProp.TotalDeposits, TradingAccountProp.TotalDoneDeposits, TradingAccountProp.TotalWithdrawals, TradingAccountProp.TradePlatformDepartment, TradingAccountProp.TradePlatformProfiles, TradingAccountProp.TradePlatformServer, TradingAccountProp.TradePlatformType, TradingAccountProp.TradingAccountInstrumentType, TradingAccountProp.TradingAccountMode, TradingAccountProp.TradingAccountStatus, TradingAccountProp.TradingAccountType, TradingAccountProp.TradingTotalsEquity, TradingAccountProp.TradingTotalsEquityTACcy, TradingAccountProp.TradingTotalsMarginFree, TradingAccountProp.TradingTotalsMarginFreeTACcy, TradingAccountProp.TradingTotalsMarginLevel, TradingAccountProp.TradingTotalsModificationTime, TradingAccountProp.TtaClearingCode, TradingAccountProp.TtaClientDomain, TradingAccountProp.UserName])

export type TradingAccountTab = 
	TradingAccountPropId & 
	TradingAccountPropCustomerId & 
	TradingAccountPropCustomerPersonFirstName & 
	TradingAccountPropCustomerPersonLastName & 
	TradingAccountPropTradePlatformType & 
	TradingAccountPropTradingAccountType & 
	TradingAccountPropCurrency & 
	TradingAccountPropName & 
	TradingAccountPropCustomerBrandCompanyId

export const TRADING_ACCOUNT_TAB_PROPERTY_NAMES = Object.freeze([TradingAccountProp.Id, TradingAccountProp.CustomerId, TradingAccountProp.CustomerPersonFirstName, TradingAccountProp.CustomerPersonLastName, TradingAccountProp.TradePlatformType, TradingAccountProp.TradingAccountType, TradingAccountProp.Currency, TradingAccountProp.Name, TradingAccountProp.CustomerBrandCompanyId])

export type TradingAccountHistoryTab = 
	TradingAccountPropId & 
	TradingAccountPropCustomerId & 
	TradingAccountPropCustomerPersonFirstName & 
	TradingAccountPropCustomerPersonLastName & 
	TradingAccountPropTradePlatformType & 
	TradingAccountPropTradingAccountType & 
	TradingAccountPropCurrency

export const TRADING_ACCOUNT_HISTORY_TAB_PROPERTY_NAMES = Object.freeze([TradingAccountProp.Id, TradingAccountProp.CustomerId, TradingAccountProp.CustomerPersonFirstName, TradingAccountProp.CustomerPersonLastName, TradingAccountProp.TradePlatformType, TradingAccountProp.TradingAccountType, TradingAccountProp.Currency])

export type TradingAccountHeader = 
	TradingAccountPropId & 
	TradingAccountPropCustomerId & 
	TradingAccountPropCustomer$name & 
	TradingAccountPropName

export const TRADING_ACCOUNT_HEADER_PROPERTY_NAMES = Object.freeze([TradingAccountProp.Id, TradingAccountProp.CustomerId, TradingAccountProp.Customer$name, TradingAccountProp.Name])

export type TradingAccountInformation = 
	TradingAccountPropId & 
	TradingAccountPropCreatedBy & 
	TradingAccountPropCreationTime & 
	TradingAccountPropModificationTime & 
	TradingAccountPropModifiedBy & 
	TradingAccountPropTradePlatformType & 
	TradingAccountPropTradingAccountType & 
	TradingAccountPropTradingAccountStatus & 
	TradingAccountPropCustomerOneClickClosingAccountStatus & 
	TradingAccountPropDeactivationSource & 
	TradingAccountPropUserName & 
	TradingAccountPropPlatformAccountId & 
	TradingAccountPropTradePlatformServer & 
	TradingAccountPropTradePlatformDepartment & 
	TradingAccountPropTradePlatformProfiles & 
	TradingAccountPropDemoExpirationDate & 
	TradingAccountPropIslamic & 
	TradingAccountPropTest & 
	TradingAccountPropOmnibus & 
	TradingAccountPropCustomerId & 
	TradingAccountPropCustomerPersonFirstName & 
	TradingAccountPropCustomerPersonLastName & 
	TradingAccountPropBusinessGroup$list & 
	TradingAccountPropTradingAccountMode & 
	TradingAccountPropTradingAccountInstrumentType & 
	TradingAccountPropLeverage$list & 
	TradingAccountPropTitleTransfer & 
	TradingAccountPropReportingType & 
	TradingAccountPropCurrency & 
	TradingAccountPropReportUrl & 
	TradingAccountPropTaxReportUrl & 
	TradingAccountPropBrokerCode & 
	TradingAccountPropBrokerGroup & 
	TradingAccountPropForbidPasswordSync & 
	TradingAccountPropLastSynchErrorMsg & 
	TradingAccountPropDescription

export const TRADING_ACCOUNT_INFORMATION_PROPERTY_NAMES = Object.freeze([TradingAccountProp.Id, TradingAccountProp.CreatedBy, TradingAccountProp.CreationTime, TradingAccountProp.ModificationTime, TradingAccountProp.ModifiedBy, TradingAccountProp.TradePlatformType, TradingAccountProp.TradingAccountType, TradingAccountProp.TradingAccountStatus, TradingAccountProp.CustomerOneClickClosingAccountStatus, TradingAccountProp.DeactivationSource, TradingAccountProp.UserName, TradingAccountProp.PlatformAccountId, TradingAccountProp.TradePlatformServer, TradingAccountProp.TradePlatformDepartment, TradingAccountProp.TradePlatformProfiles, TradingAccountProp.DemoExpirationDate, TradingAccountProp.Islamic, TradingAccountProp.Test, TradingAccountProp.Omnibus, TradingAccountProp.CustomerId, TradingAccountProp.CustomerPersonFirstName, TradingAccountProp.CustomerPersonLastName, TradingAccountProp.BusinessGroup$list, TradingAccountProp.TradingAccountMode, TradingAccountProp.TradingAccountInstrumentType, TradingAccountProp.Leverage$list, TradingAccountProp.TitleTransfer, TradingAccountProp.ReportingType, TradingAccountProp.Currency, TradingAccountProp.ReportUrl, TradingAccountProp.TaxReportUrl, TradingAccountProp.BrokerCode, TradingAccountProp.BrokerGroup, TradingAccountProp.ForbidPasswordSync, TradingAccountProp.LastSynchErrorMsg, TradingAccountProp.Description])

export type TradingAccountTradingActivities = 
	TradingAccountPropTradingTotalsEquity & 
	TradingAccountPropTradingTotalsEquityTACcy & 
	TradingAccountPropTradingTotalsModificationTime & 
	TradingAccountPropTradingTotalsMarginLevel & 
	TradingAccountPropTradingTotalsMarginFreeTACcy & 
	TradingAccountPropTradingTotalsMarginFree & 
	TradingAccountPropNumberOfDeposits & 
	TradingAccountPropTotalDeposits & 
	TradingAccountPropNumberOfDoneDeposits & 
	TradingAccountPropTotalDoneDeposits & 
	TradingAccountPropCurrency & 
	TradingAccountPropNumberOfWithdrawals & 
	TradingAccountPropTotalWithdrawals & 
	TradingAccountPropPaymentReference & 
	TradingAccountPropMoneyManager

export const TRADING_ACCOUNT_TRADING_ACTIVITIES_PROPERTY_NAMES = Object.freeze([TradingAccountProp.TradingTotalsEquity, TradingAccountProp.TradingTotalsEquityTACcy, TradingAccountProp.TradingTotalsModificationTime, TradingAccountProp.TradingTotalsMarginLevel, TradingAccountProp.TradingTotalsMarginFreeTACcy, TradingAccountProp.TradingTotalsMarginFree, TradingAccountProp.NumberOfDeposits, TradingAccountProp.TotalDeposits, TradingAccountProp.NumberOfDoneDeposits, TradingAccountProp.TotalDoneDeposits, TradingAccountProp.Currency, TradingAccountProp.NumberOfWithdrawals, TradingAccountProp.TotalWithdrawals, TradingAccountProp.PaymentReference, TradingAccountProp.MoneyManager])

export type TradingAccountPreview = 
	TradingAccountPropId & 
	TradingAccountPropPlatformAccountId & 
	TradingAccountPropTradePlatformType

export const TRADING_ACCOUNT_PREVIEW_PROPERTY_NAMES = Object.freeze([TradingAccountProp.Id, TradingAccountProp.PlatformAccountId, TradingAccountProp.TradePlatformType])

export type TradingAccountCreate = 
	TradingAccountPropCustomerId & 
	TradingAccountPropTradePlatformType & 
	TradingAccountPropTradingAccountType & 
	TradingAccountPropCurrency & 
	TradingAccountPropDemoExpirationDate & 
	TradingAccountPropLeverage & 
	TradingAccountPropTitleTransfer & 
	TradingAccountPropReportingType & 
	TradingAccountPropForbidPasswordSync & 
	TradingAccountPropTradingAccountInstrumentType & 
	TradingAccountPropIslamic & 
	TradingAccountPropOmnibus & 
	TradingAccountPropExistsAtPlatform & 
	TradingAccountPropPlatformAccountId & 
	TradingAccountPropDescription & 
	TradingAccountPropTtaClientDomain & 
	TradingAccountPropTtaClearingCode & 
	TradingAccountPropBrokerCode & 
	TradingAccountPropBrokerGroup

export const TRADING_ACCOUNT_CREATE_PROPERTY_NAMES = Object.freeze([TradingAccountProp.CustomerId, TradingAccountProp.TradePlatformType, TradingAccountProp.TradingAccountType, TradingAccountProp.Currency, TradingAccountProp.DemoExpirationDate, TradingAccountProp.Leverage, TradingAccountProp.TitleTransfer, TradingAccountProp.ReportingType, TradingAccountProp.ForbidPasswordSync, TradingAccountProp.TradingAccountInstrumentType, TradingAccountProp.Islamic, TradingAccountProp.Omnibus, TradingAccountProp.ExistsAtPlatform, TradingAccountProp.PlatformAccountId, TradingAccountProp.Description, TradingAccountProp.TtaClientDomain, TradingAccountProp.TtaClearingCode, TradingAccountProp.BrokerCode, TradingAccountProp.BrokerGroup])
